import styled, { css } from "styled-components";
import {
  flexBoxCenter,
  justifyContentSpaceEvenly,
  layerA180Deg,
  layerADark,
  layerB,
} from "shared/styles/commonStyles";
import SearchButton from "./SearchButton";
import SelectSystem from "./SelectSystem";
import SelectDates from "./SelectDates";
import SelectSwitches from "./SelectSwitches";
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  essSpecificLocationUnselectMachinesHandler,
  handleUnSelectIndividualMachine,
  selectEssSwitch,
} from "shared/slice/essSwitchSlice";
import {
  selectTgsSwitch,
  tgsHandleUnSelectIndividualMachine,
  tgsSpecificLocationUnselectMachinesHandler,
} from "shared/slice/tgsSwitchSlice";
import {
  selectTesSwitch,
  tesHandleUnSelectIndividualMachine,
  tesSpecificLocationUnselectMachinesHandler,
} from "shared/slice/tesSwitchSlice";
import { useEffect } from "react";
import {

  handleSelectTelemetrySystem,


  handleUnselectAllSystem,
  selectMC,
} from "shared/slice/mCSlice";
import {
  handleDisplaySelectBox,
  handleLocationSelect,
  handleMachineSelect,
  handleResetAllSelect,
  handleSelectAll,
  handleSpecificLocationSelect,
  selectMasterControls,
} from "shared/slice/masterControlSelectSlice";
import {
  handleAuditLogData,
  handleSearchTelemetrySystem,
  handleTotalConsumptionTelemetry,
  handleTotalHoursTelemetry,
} from "features/telemetry/slice/telemetrySlice";
import {
  hpEcHandleUnSelectIndividualMachine,
  hpEcSpecificLocationUnselectMachinesHandler,
  selectHpElectricSwitch,
} from "shared/slice/hpElectricSwitchSlice";
import {
  hpGcHandleUnSelectIndividualMachine,
  hpGcSpecificLocationUnselectMachinesHandler,
  selectHpGasSwitch,
} from "shared/slice/hpGasSwitchSlice";
import {
  essDataConsumptionHandleUnSelectIndividualMachine,
  essDataConsumptionSpecificLocationUnselectMachineHandler,

  selectEssDataConsumption,
} from "shared/slice/essDataConsumptionSlice";
import {
  selectTesDataConsumption,


  tesDataConsumptionHandleUnSelectIndividualMachine,
  tesDataConsumptionSpecificLocationUnselectMachineHandler,
} from "shared/slice/tesDataConsumptionSlice";
import {
  selectTgsDataConsumption,

  tgsDataConsumptionHandleUnSelectIndividualMachine,
  tgsDataConsumptionSpecificLocationUnselectMachineHandler,
} from "shared/slice/tgsDataConsumptionSlice";
import {
  hpDataConsumptionHandleUnSelectIndividualMachine,
  hpDataConsumptionSpecificLocationUnselectMachinesHandler,
  selectHpDataConsumption,
} from "shared/slice/hpDataConsumptionSlice";
import {
  selectTelemetryChartData,
  setTelemetryChartData,
  setTelemetryIntervalUnit,
} from "features/telemetry/slice/telemetryChartDataSlice";
import {
  formatDataConsumptionTotal,
  formatTelemetryChartData,
  formatTime,



  getMachineDataByInhandId,
  getSelectedDeviceIds,
  getTotalMachineValues,
  getTotalSearchValues,
  isTelemetrySearchReady,
} from "shared/helpers/helpers";
import MessageBox from "shared/components/userMessages/messageBox";
import {
  getDataConsumptionService,
  getTelemetryService,
} from "shared/services";

import { selectUnits } from "shared/slice/unitsSlice";
import { useLocations } from "shared/hooks";

const MainSelections = ({
  selectedSystemTitle,
  setSelectedSystemTitle,
  setControlSelectionDisplay,
  setTelemetryData,
  setTelemetryDataKeys,
  setCopyTelemetryState,
  setCopyTelemetryStateKeys,
  setCopyTelemetryDailyState,
  scheduleData,
  setScheduleData,
  setSelectSpecific,
}) => {

  const buttonsTitle = ["clear", "apply"];

  const selectConsumptionType = [
    "data consumption",
    "energy consumption",
    "gas consumption",
  ];

  const dataConsumption = [
    "ess - electric switch systems - dc",
    "tgs - typhoon gas systems - dc",
    "tes - typhoon electric systems - dc",
    "hp - heating platform - dc",
  ];

  const electricConsumption = [
    "ess - electric switch systems - ec",
    "tes - typhoon electric systems - ec",
    "hp - heating platform - ec",
  ];

  const gasConsumption = [
    "tgs - typhoon gas systems - gc",
    "hp - heating platform - gc",
  ];


  const dispatch = useDispatch();

  const { isF } = useSelector(selectUnits);
  const locations = useLocations();
  const selectedSwitch = useSelector(selectMC);
  const { essDc, tgsTesDc, hpDc, tgs, hpGc, ess, tes, hpEc } =
    selectedSwitch.selectSystem;
  const masterControlSelects = useSelector(selectMasterControls);

  const { displaySelectBox } = masterControlSelects;
  const { selectedOne } = ess
    ? masterControlSelects.ess
    : tes
    ? masterControlSelects.tes
    : tgs
    ? masterControlSelects.tgs
    : essDc
    ? masterControlSelects.essDc
    : tgsTesDc
    ? masterControlSelects.tgsTesDc
    : hpDc
    ? masterControlSelects.hpDc
    : hpEc
    ? masterControlSelects.hpEc
    : hpGc && masterControlSelects.hpGc;

  const selectedSwitches = ess
    ? masterControlSelects.ess.selectedOne
    : tes
    ? masterControlSelects.tes.selectedOne
    : tgs
    ? masterControlSelects.tgs.selectedOne
    : essDc
    ? masterControlSelects.essDc.selectedOne
    : tgsTesDc
    ? masterControlSelects.tgsTesDc.selectedOne
    : hpDc
    ? masterControlSelects.hpDc.selectedOne
    : hpEc
    ? masterControlSelects.hpEc.selectedOne
    : hpGc
    ? masterControlSelects.hpGc.selectedOne
    : false;


  const { essSwitch, flatEssSwitch } = useSelector(selectEssSwitch);
  const { tesSwitch, flatTesSwitch } = useSelector(selectTesSwitch);
  const { tgsSwitch, flatTgsSwitch } = useSelector(selectTgsSwitch);
  const hpElectricSwitch = useSelector(selectHpElectricSwitch);
  const hpGasSwitch = useSelector(selectHpGasSwitch);
  const { essDataConsumptionSwitch, essDataConsumptionSwitchSpecificLocation } =
    useSelector(selectEssDataConsumption);
  const { tesDataConsumptionSwitch, tesDataConsumptionSwitchSpecificLocation } =
    useSelector(selectTesDataConsumption);
  const { tgsDataConsumptionSwitch, tgsDataConsumptionSwitchSpecificLocation } =
    useSelector(selectTgsDataConsumption);
  const hpDataConsumptionSwitch = useSelector(selectHpDataConsumption);
  const chartData = useSelector(selectTelemetryChartData);
  const {
    essSwitchData,
  } = chartData;

  const [systemGreenCircle, setSystemGreenCircle] = useState(null);
  const [openSelections, setOpenSelections] = useState(false);
  const [selectedDeviceIds, setselectedDeviceIds] = useState([]);
  const [isExpanded, setIsExpanded] = useState([false, false, false]);
  const [abrSelectedSystemTitle, setAbrSelectedSystemTitle] = useState(null);
  const [openMessageBox, setOpenMessageBox] = useState(false);

  const unSelectSpecificLocationMachines = (
    swt,
    specificLocationKeys,
    machinesData,
    location
  ) => {
    specificLocationKeys.forEach((specificLocation) => {
      machinesData.forEach((machine) => {
        const machineKey = Object.keys(machine)[0];
        const dispatchOjb = {
          location,
          specificLocation,
          machine: machineKey,
        };
        if (swt === "ess") {
          dispatch(essSpecificLocationUnselectMachinesHandler(dispatchOjb));
        } else if (swt === "tes") {
          dispatch(tesSpecificLocationUnselectMachinesHandler(dispatchOjb));
        } else if (swt === "tgs") {
          dispatch(tgsSpecificLocationUnselectMachinesHandler(dispatchOjb));
        } else if (swt === "essDc") {
          dispatch(
            essDataConsumptionSpecificLocationUnselectMachineHandler(
              dispatchOjb
            )
          );
        } else if (swt === "tgsTesDc") {
          dispatch(
            tesDataConsumptionSpecificLocationUnselectMachineHandler(
              dispatchOjb
            )
          );
          dispatch(
            tgsDataConsumptionSpecificLocationUnselectMachineHandler(
              dispatchOjb
            )
          );
        } else if (swt === "hpEc") {
          dispatch(hpEcSpecificLocationUnselectMachinesHandler(dispatchOjb));
        } else if (swt === "hpGc") {
          dispatch(hpGcSpecificLocationUnselectMachinesHandler(dispatchOjb));
        } else if (swt === "hpDc") {
          dispatch(
            hpDataConsumptionSpecificLocationUnselectMachinesHandler(
              dispatchOjb
            )
          );
        }
      });
    });
  };

  const handleUnSelectMachines = (location, swt, switchData) => {
    if (!location || !switchData?.[location]) return;
    const el = Object.keys(switchData[location]);
    const elValue = Object.values(switchData[location]);
    const isDirectMachineMap =
      !switchData[location]?.isSpecificLocation &&
      elValue.some(
        (value) =>
          value &&
          typeof value === "object" &&
          ("machineType" in value || "deviceMac" in value || "isSelected" in value)
      );

    if (isDirectMachineMap) {
      el.forEach((machine) => {
        if (swt === "ess") {
          dispatch(handleUnSelectIndividualMachine({ location, machine }));
        } else if (swt === "tes") {
          dispatch(tesHandleUnSelectIndividualMachine({ location, machine }));
        } else if (swt === "tgs") {
          dispatch(tgsHandleUnSelectIndividualMachine({ location, machine }));
        } else if (swt === "hpEc") {
          dispatch(hpEcHandleUnSelectIndividualMachine({ location, machine }));
        } else if (swt === "hpGc") {
          dispatch(hpGcHandleUnSelectIndividualMachine({ location, machine }));
        } else if (swt === "essDc") {
          dispatch(
            essDataConsumptionHandleUnSelectIndividualMachine({
              location,
              machine,
            })
          );
        } else if (swt === "tgsTesDc") {
          dispatch(
            tesDataConsumptionHandleUnSelectIndividualMachine({
              location,
              machine,
            })
          );
          dispatch(
            tgsDataConsumptionHandleUnSelectIndividualMachine({
              location,
              machine,
            })
          );
        } else if (swt === "hpDc") {
          dispatch(
            hpDataConsumptionHandleUnSelectIndividualMachine({
              location,
              machine,
            })
          );
        }
      });
    } else if (elValue.length > 0) {
      unSelectSpecificLocationMachines(swt, el, elValue, location);
    }


  };



  const loopAllMachinesHandler = (selectedSwitches, selectedSys) => {
    const locations = selectedSwitches ? Object.keys(selectedSwitches) : [];
    locations.map((location) =>
      handleUnSelectMachines(location, selectedSys, selectedSwitches)
    );
  };

  useEffect(() => {


    dispatch(handleResetAllSelect());
    if (ess) {
      loopAllMachinesHandler(flatEssSwitch, "ess");


    } else if (tes) {
      loopAllMachinesHandler(flatTesSwitch, "tes");



    } else if (tgs) {
      loopAllMachinesHandler(flatTgsSwitch, "tgs");



    } else if (hpEc) {
      loopAllMachinesHandler(hpElectricSwitch, "hpEc");
    } else if (hpGc) {
      loopAllMachinesHandler(hpGasSwitch, "hpGc");
    } else if (essDc) {
      loopAllMachinesHandler(essDataConsumptionSwitch, "essDc");




    } else if (tgsTesDc) {
      loopAllMachinesHandler(tesDataConsumptionSwitch, "tgsTesDc");
      loopAllMachinesHandler(tgsDataConsumptionSwitch, "tgsTesDc");




    } else if (tgsTesDc) {



    } else if (hpDc) {
      loopAllMachinesHandler(hpDataConsumptionSwitch, "hpDc");
    }

    return () => {
      dispatch(handleSearchTelemetrySystem(false));
    };
  }, [ess, tes, tgs, essDc, tgsTesDc, hpDc, hpGc, hpEc]);





  const presetSelectBoxArr = (swt, swtData) => {
    if (!swtData) return;

    const essLocations = Object.keys(swtData);
    dispatch(handleSelectAll({ switch: swt, status: false }));

    const locationArr = essLocations.map((location) => false);
    dispatch(handleLocationSelect({ arr: locationArr, switch: swt }));

    const specificLocationArr = [];
    const machineArr = Object.values(swtData).map((location) => {
      if (location?.isSpecificLocation) {
        const subLocations = location.subLocations || {};
        const machinesList = Object.values(subLocations).map(
          (specLocation) => Object.keys(specLocation?.devices || {}).map((el) => false)
        );
        const specLocation = Object.keys(subLocations).map(
          (el) => false
        );
        specificLocationArr.push(specLocation);
        return machinesList;
      } else {
        const machines = location?.devices || location || {};
        return Object.values(machines).map((value) => {
          return false;
        });
      }
    });


    dispatch(
      handleSpecificLocationSelect({
        arr: specificLocationArr,
        switch: swt,
      })
    );


    dispatch(handleMachineSelect({ arr: machineArr, switch: swt }));
  };

  useEffect(() => {
    if (ess) {
      if (!selectedOne) {

        presetSelectBoxArr("ess", essSwitch);
      }
    } else if (tes) {
      if (!selectedOne) {


        presetSelectBoxArr("tes", tesSwitch);
      }
    } else if (tgs) {
      if (!selectedOne) {
        presetSelectBoxArr("tgs", tgsSwitch);


      }
    } else if (essDc) {
      if (!selectedOne) {
        presetSelectBoxArr("essDc", essDataConsumptionSwitchSpecificLocation);


      }
    } else if (tgsTesDc) {
      if (!selectedOne) {
        presetSelectBoxArr(
          "tgsTesDc",
          tesDataConsumptionSwitchSpecificLocation
        );


      }
    } else if (tgsTesDc) {
      if (!selectedOne) {
        presetSelectBoxArr(
          "tgsTesDc",
          tgsDataConsumptionSwitchSpecificLocation
        );


      }
    } else if (hpDc) {
      if (!selectedOne) {
        presetSelectBoxArr("hpDc", hpDataConsumptionSwitch);
      }
    } else if (hpEc) {
      if (!selectedOne) {
        presetSelectBoxArr("hpEc", hpElectricSwitch);
      }
    } else if (hpGc) {
      if (!selectedOne) {
        presetSelectBoxArr("hpGc", hpGasSwitch);
      }
    }

    return () => {};
  }, [
    selectedOne,
    selectedSwitch,
    ess,
    tes,
    tgs,
    essDc,
    tgsTesDc,
    hpDc,
    hpGc,
    hpEc,
  ]);



  const [arrowImg, setArrowImg] = useState([
    "/images/white-triangle-pointing-right.svg",
    "/images/white-triangle-pointing-right.svg",
    "/images/white-triangle-pointing-right.svg",
  ]);

  const handleExpansion = (idx) => {
    const copyArrowImg = [...arrowImg];
    const copyIsExpanded = [...isExpanded];

    copyIsExpanded[idx] = !isExpanded[idx];
    setIsExpanded(copyIsExpanded);

    if (isExpanded[idx] === true) {
      copyArrowImg[idx] = "/images/white-triangle-pointing-right.svg";
    } else copyArrowImg[idx] = "/images/masterCtr-select-btn.svg";
    setArrowImg(copyArrowImg);
  };



  const onSelectSystem = (index) => {
    if (systemGreenCircle === index) {
      setSelectedSystemTitle(null);
      setSystemGreenCircle(null);
      setAbrSelectedSystemTitle(null);
      setControlSelectionDisplay(false);
      return;
    }

    switch (index) {
      case 0:
        setSelectedSystemTitle("ess - dc");
        setSystemGreenCircle(index);
        setAbrSelectedSystemTitle("essDc");
        setControlSelectionDisplay(false);
        break;
      case 1:
        setSelectedSystemTitle("tgs/tes - dc");
        setSystemGreenCircle(index);
        setAbrSelectedSystemTitle("tgsTesDc");
        setControlSelectionDisplay(false);
        break;
      case 2:
        setSelectedSystemTitle("tgs/tes - dc");
        setSystemGreenCircle(index);
        setAbrSelectedSystemTitle("tgsTesDc");
        setControlSelectionDisplay(false);
        break;
      case 3:
        setSelectedSystemTitle("hp - heating platform - dc");
        setSystemGreenCircle(index);
        setAbrSelectedSystemTitle("hpDc");
        setControlSelectionDisplay(false);
        break;
      case 4:
        setSelectedSystemTitle("ess - electric switch systems - ec");
        setSystemGreenCircle(index);
        setAbrSelectedSystemTitle("ess");
        setControlSelectionDisplay(false);
        break;
      case 5:
        setSelectedSystemTitle("tes - typhoon electric systems - ec");
        setSystemGreenCircle(index);
        setAbrSelectedSystemTitle("tes");
        setControlSelectionDisplay(false);
        break;
      case 6:
        setSelectedSystemTitle("hp - heating platform - ec");
        setSystemGreenCircle(index);
        setAbrSelectedSystemTitle("hpEc");
        setControlSelectionDisplay(false);
        break;
      case 7:
        setSelectedSystemTitle("tgs - typhoon gas systems - gc");
        setSystemGreenCircle(index);
        setAbrSelectedSystemTitle("tgs");
        setControlSelectionDisplay(false);
        break;
      case 8:
        setSelectedSystemTitle("hp - heating platform - gc");
        setSystemGreenCircle(index);
        setAbrSelectedSystemTitle("hpGc");
        setControlSelectionDisplay(false);
        break;
      default:
        break;
    }
  };


  const handleSelectSystemsButton = useCallback(
    (index) => {
      switch (index) {
        case 0:
          setselectedDeviceIds([]);
          setSelectedSystemTitle(null);
          setSystemGreenCircle(null);
          setAbrSelectedSystemTitle(null);
          dispatch(handleUnselectAllSystem());
          break;
        case 1:
          if (abrSelectedSystemTitle) {
            dispatch(handleSelectTelemetrySystem(abrSelectedSystemTitle));
          } else {
            dispatch(handleUnselectAllSystem());
          }
          setOpenSelections(false);
          break;
        default:
          break;
      }
    },
    [abrSelectedSystemTitle]
  );


  const handleButtonClick = () => {
    dispatch(handleDisplaySelectBox());
  };


  const getTelemetryData = (swtName, isDc, category) => {
    setTelemetryData([]);
    setTelemetryDataKeys([]);
    const startDate = formatTime(scheduleData.start, true);
    const endDate = formatTime(scheduleData.end, true);
    const swtSwitch = ess ? flatEssSwitch : tes ? flatTesSwitch : flatTgsSwitch;
    const swtSwitchE = ess ? essSwitch : tes ? tesSwitch : tgsSwitch;
    const deviceIds = getSelectedDeviceIds(
      masterControlSelects,
      swtSwitchE,
      swtName
    );
    const flatdeviceIds = deviceIds.flat();
    if (ess || tes || tgs) {
      getTelemetryService({ deviceIds: flatdeviceIds, startDate, endDate, category }).then(
        ({ data, unit }) => {
          const { intervalData, intervalKeys } = formatTelemetryChartData(
            data,
            swtName,
            swtSwitch,
            isF
          );
          const totalHours = getTotalSearchValues(data, "hourOfUsage");
          const totalConsumption = getTotalSearchValues(
            data,
            "consumption",
            swtName,
            isF
          );





          const auditLogData = {
            actionType: "GLOBAL_TELEMETRY_OVERVIEW",
            deviceIds,
            deviceType: swtName.toUpperCase(),
            data: {
              startDate,
              endDate,
              isDataConsumption: isDc,
              totalUsageHours: totalHours,
              totalConsumption: totalConsumption,
              data: intervalData.map((machine) => {
                return {
                  deviceId: machine.machine,
                  usageHours: machine.totalUsageHours,
                  consumption: machine.totalConsumption,
                };
              }),
            },
          };

          dispatch(
            setTelemetryChartData({
              swtName: `${swtName}SwitchData`,
              data: {
                monthlyData: intervalData,
                monthlyKeys: intervalKeys,
              },
            })
          );
          dispatch(setTelemetryIntervalUnit(unit));
          dispatch(handleTotalHoursTelemetry(totalHours));
          dispatch(handleTotalConsumptionTelemetry(totalConsumption));
          setTelemetryData(intervalData);
          setCopyTelemetryState(intervalData);
          setCopyTelemetryDailyState(essSwitchData?.dailyData || []);
          setTelemetryDataKeys(intervalKeys);
          setCopyTelemetryStateKeys(intervalKeys);
          dispatch(handleAuditLogData(auditLogData));
        }
      ).catch((error) => {
        console.error("Error fetching telemetry data:", error);
      });

    }

    if (essDc || tgsTesDc) {
      const getinhandsIds = (selectedDevice, swtSwitch) => {
        if (!selectedDevice || !swtSwitch) return [];

        const { location, specificLocation, device } = selectedDevice;

        const locationData = swtSwitch[location] || swtSwitch[specificLocation];

        if (device) {
          const deviceData = locationData?.[device];
          return deviceData?.inhandId ? [deviceData.inhandId] : [];
        }

        if (locationData) {
          const allInhandIds = Object.values(locationData)
            .map((d) => d.inhandId)
            .filter(Boolean);
          if (allInhandIds.length > 0) return allInhandIds;
        }

        if (locationData === undefined) {
          if (location && !specificLocation && !device) {
            const locData = locations.all[location];

            const subLocs = locData.specific_location;

            if (subLocs) {
              const allSubInhandIds = Object.values(subLocs).flatMap(
                (subLoc) => {
                  const specificId = subLoc.zone_id;

                  const subLocData = swtSwitch[specificId];
                  if (!subLocData) {
                    return [];
                  }

                  const ids = Object.values(subLocData)
                    .map((d) => d.inhandId)
                    .filter(Boolean);

                  return ids;
                }
              );

              if (allSubInhandIds.length > 0) return allSubInhandIds;
            }
          } else {
            return [];
          }
        }

        return [];
      };

      const getAllInhandIds = (selectedDevices = [], swtSwitch) => {
        if (!Array.isArray(selectedDevices) || !swtSwitch) return [];

        const allIds = selectedDevices.flatMap((selectedDevice) =>
          getinhandsIds(selectedDevice, swtSwitch)
        );

        const uniqueIds = [...new Set(allIds)];

        return uniqueIds;
      };

      const swtSwitch = essDc
        ? essDataConsumptionSwitch
        : tgsTesDc
        ? tesDataConsumptionSwitch
        : tgsDataConsumptionSwitch;

      const inhandIds = getAllInhandIds(selectedDeviceIds, swtSwitch);
      if (inhandIds.length) {
        getDataConsumptionService({ inhandIds, startDate, endDate }).then(
          (res) => {
            const intervalData = Object.values(res).map((machine, index) => {
              const machineData = getMachineDataByInhandId(
                Object.keys(res)[index],
                swtSwitch
              );
              return {
                machine: machineData.machineMac,
                switch: `${machineData.locationName} - ${machineData.machineName}`,
                isSelected: true,
                totalUsageHours: getTotalMachineValues(machine, "hourOfUsage"),
                totalConsumption: getTotalMachineValues(machine, "total"),
                barColor: "#FF0080",
                ...machine
                  .filter((el) => el.start_date)
                  .map((el, index) => {
                    const intervalName = el.start_date;
                    return {
                      [intervalName]: formatDataConsumptionTotal(el.total),
                      [`${intervalName}TEC`]: `${formatDataConsumptionTotal(
                        el.total
                      )} GB`,
                      [`${intervalName}THU`]: `${Math.floor(
                        el.hourOfUsage || 0
                      )} hours`,
                      [`${intervalName}Color`]:
                        index % 2 === 0 ? "#FF0080" : "#FF00D5",
                    };
                  })
                  .reduce((cur, result) => {
                    return { ...result, ...cur };
                  }, {}),
              };
            });

            const intervalKeys = [
              ...new Set(
                Object.values(res)
                  .map((machine) => {
                    return machine
                      .filter((el) => el.start_date)
                      .map((el) => el.start_date);
                  })
                  .flat()
              ),
            ];

            const totalHours = getTotalSearchValues(
              Object.values(res),
              "hourOfUsage",
              null,
              null,
              isDc
            );
            const totalConsumption = getTotalSearchValues(
              Object.values(res),
              "total",
              null,
              null,
              isDc
            );
            const auditLogData = {
              actionType: "GLOBAL_DATA_TELEMETRY_OVERVIEW",
              deviceIds: intervalData.map((machine) => machine.machine),
              deviceType: swtName.toUpperCase(),
              reportIds: inhandIds,
              data: {
                startDate,
                endDate,
                isDataConsumption: isDc,
                totalUsageHours: totalHours,
                totalConsumption: totalConsumption,
                data: intervalData.map((machine) => {
                  return {
                    deviceId: machine.machine,
                    usageHours: machine.totalUsageHours,
                    consumption: machine.totalConsumption,
                  };
                }),
              },
            };

            dispatch(
              setTelemetryChartData({
                swtName: `${swtName}DataConsumpData`,
                data: {
                  monthlyData: intervalData,
                  monthlyKeys: intervalKeys,
                },
              })
            );
            dispatch(setTelemetryIntervalUnit("months"));
            dispatch(handleTotalHoursTelemetry(totalHours));
            dispatch(handleTotalConsumptionTelemetry(totalConsumption));
            setTelemetryData(intervalData);
            setTelemetryDataKeys(intervalKeys);
            dispatch(handleAuditLogData(auditLogData));
          }
        );
      } else {
        dispatch(
          setTelemetryChartData({
            swtName: `${swtName}DataConsumpData`,
            data: {
              monthlyData: [],
              monthlyKeys: [],
            },
          })
        );
        dispatch(handleTotalHoursTelemetry(0));
        dispatch(handleTotalConsumptionTelemetry(0));
        setTelemetryData([]);
        setTelemetryDataKeys([]);
      }
    }
  };

  const handleClickSearch = () => {
    const isSystemSelected =
      ess || tgs || tes || essDc || tgsTesDc || hpDc || hpGc || hpEc;

    if (
      !isTelemetrySearchReady(isSystemSelected, selectedSwitches, scheduleData)
    ) {
      setOpenMessageBox(true);
      return;
    }

    dispatch(handleSearchTelemetrySystem(true));
    setControlSelectionDisplay(true);
    if (ess) {
      getTelemetryData("ess", false, "energy");
    } else if (tgs) {
      getTelemetryData("tgs", false, "fuel");
    } else if (tes) {
      getTelemetryData("tes", false, "energy");
    } else if (essDc) {
      getTelemetryData("ess", true);
    } else if (tgsTesDc) {
      getTelemetryData("tgs", true);
    } else if (hpDc || hpGc || hpEc) {
      setTelemetryData([]);
      setCopyTelemetryState([]);
      setCopyTelemetryDailyState([]);
      setTelemetryDataKeys([]);
    }
  };

  return (
    <ShadowWrapper positionRelative={openMessageBox}>
      <Wrapper>
        <IndentWrapper>
          <SelectSystem
            gasSystems={gasConsumption}
            electricSystems={electricConsumption}
            dataSystems={dataConsumption}
            buttons={buttonsTitle}
            title={selectedSystemTitle}
            systemIndex={systemGreenCircle}
            onSelect={onSelectSystem}
            onClickButton={handleSelectSystemsButton}
            openSelections={openSelections}
            setOpenSelections={setOpenSelections}
            selectConsumptionType={selectConsumptionType}
            handleExpansion={handleExpansion}
            isExpanded={isExpanded}
            arrowImg={arrowImg}
          />

          <SelectSwitches
            selectedOne={selectedOne}
            ess={ess}
            tgs={tgs}
            tes={tes}
            essDc={essDc}
            tgsTesDc={tgsTesDc}

            hpDc={hpDc}
            hpGc={hpGc}
            hpEc={hpEc}
            displaySelectBox={displaySelectBox}
            essSwitch={essSwitch}
            tesSwitch={tesSwitch}
            tgsSwitch={tgsSwitch}

            hpElectricSwitch={hpElectricSwitch}
            hpGasSwitch={hpGasSwitch}
            essDataConsumptionSwitch={essDataConsumptionSwitchSpecificLocation}
            tesDataConsumptionSwitch={tesDataConsumptionSwitchSpecificLocation}
            tgsDataConsumptionSwitch={tgsDataConsumptionSwitchSpecificLocation}
            hpDataConsumptionSwitch={hpDataConsumptionSwitch}
            handleButtonClick={handleButtonClick}
            selectedDeviceIds={selectedDeviceIds}
            setselectedDeviceIds={setselectedDeviceIds}
            setSelectSpecific={setSelectSpecific}
          />

          <SelectDates
            scheduleData={scheduleData}
            setScheduleData={setScheduleData}
          />
        </IndentWrapper>
        <WrapperButton>
          <SearchButton title={"search"} onClick={handleClickSearch} />
        </WrapperButton>
      </Wrapper>
      {openMessageBox && (
        <PopupBoxWrapper>
          <MessageBox
            onClose={() => setOpenMessageBox(false)}
            title={'global system telemetry overview'}
            subtitle={'selection box'}
            messages={[
              'in order to search your telemetry overview',
              'please select a system, a switch, a start date and an end date',
            ]}
          />
        </PopupBoxWrapper>
      )}
    </ShadowWrapper>
  );
};

export default MainSelections;

const ShadowWrapper = styled.div`
  width: 1216px;
  height: 86px;
  margin-top: 8px;
  margin-bottom: 8px;

  ${layerB}

  border-radius: 49px;
  opacity: 1;
  ${flexBoxCenter}

  ${(p) =>
    p.positionRelative &&
    css`
      position: relative;
    `}
`;

const PopupBoxWrapper = styled.div`
  width: 100%;
  height: 600%;
  ${flexBoxCenter}
  position: absolute;
  top: -60px;
  left: 0px;
  z-index: 100;
`;

const Wrapper = styled.div`
  width: 1212px;
  height: 82px;

  ${layerA180Deg}

  border-radius: 47px;
  opacity: 1;
  ${justifyContentSpaceEvenly}
`;

const IndentWrapper = styled.div`
  width: 1099px;
  height: 69px;
  margin-right: 9px;

  ${layerADark}

  border-radius: 41px;
  opacity: 1;
  ${justifyContentSpaceEvenly}
`;

const WrapperButton = styled.div`
  width: auto;
  height: auto;
`;
